import { withDependencies } from '@wix/thunderbolt-ioc'
import { IModelUpdatesHandlersImplementor } from 'ds-feature-model-updates-invoker'
import { ExternalComponentDsApiSymbol, name } from '../symbols'
import { ExternalComponentData, ExternalComponentHandlers, IExternalComponentDsApi } from '../types'

export const UpdateExternalComponentFactory = withDependencies(
	[ExternalComponentDsApiSymbol],
	(externalComponentDsApi: IExternalComponentDsApi): IModelUpdatesHandlersImplementor<ExternalComponentHandlers> => {
		const prevSourceData: Record<string, string> = {}
		const getSourceData = ({ url, importKey }: ExternalComponentData) => {
			return importKey ? `${url}-${importKey}` : url
		}
		return {
			featureName: name,
			handlers: {
				updateExternalComponent: async ({ compId, data }) => {
					const newSourceData = getSourceData(data)

					if (!prevSourceData[compId]) {
						prevSourceData[compId] = newSourceData
						return
					}

					if (prevSourceData[compId] !== newSourceData) {
						prevSourceData[compId] = newSourceData
						await externalComponentDsApi.reloadExternalComponent({ compId, data })
					}
				},
			},
		}
	}
)
